// extracted by mini-css-extract-plugin
module.exports = {"card":"Skeleton_card__UKdC1","selectCabin":"Skeleton_selectCabin__aFpe_"};